import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api from '@/services/api';
import type { ActionPlan, BoardType, TaskType } from '@/types';

type Task = {
	id: string;
	type: TaskType;
	description: string;
};

type UpdateRosaActionPlanRequest = {
	id: string;
	title: string;
	deadline?: Date;
	company_id: string;
	organization_id: string;
	responsible_user_id: string;
	board: BoardType;
	description?: string;
	tasks?: Task[];
};

type UpdateRosaActionPlanResponse = { data: ActionPlan; message: string; status: string };

async function updateRosaActionPlan(params: UpdateRosaActionPlanRequest): Promise<UpdateRosaActionPlanResponse> {
	const url = `/ergonomic-tool/rosa/action-plan/${params.id}`;
	const { data } = await Api.put<UpdateRosaActionPlanResponse>(url, params);
	return data;
}

export const useUpdateRosaActionPlan = () => {
	const queryClient = useQueryClient();
	return useMutation<UpdateRosaActionPlanResponse, any, UpdateRosaActionPlanRequest>(
		(payload) => updateRosaActionPlan(payload),
		{
			onSuccess: () => {
				queryClient.invalidateQueries([]);
			}
		}
	);
};
